import { Helmet } from "react-helmet-async";
import { connect } from "react-redux";
import { DashboardController } from "../../controllers";
import { Button, CategoryCard, Layout, PolicyInfo, ProductCard, TotalCard, TotalCardMini } from "../../components";
import { LinearProgress } from "@mui/material";
import { Arrowleft, BarChart, Chart, SavedUp, FolderCheck, FolderClose , Letter, MoneySend, Plus, Policy, WalletMoney } from "../../../assets";
import "chart.js/auto";
import { Line } from "react-chartjs-2";
import routes from "../../../core/routes";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css/pagination';
import { insuranceTypeList, planTypeList, policyIcon, productIcon } from "../../../core/utils";

class Dashboard extends DashboardController {

  componentDidMount() {
    window.scrollTo(0, 0);
    this.getList();
  }
  render() {
    const { loading, dashboardData } = this.state;
    const { userData } = this.props;
    return (
      <Layout noBg noPadding title="نمایه">
        <Helmet>
          <title> نمایه | بیمه زندگی هامرز</title>
        </Helmet>
        {loading ?
          <LinearProgress />
          :
          <div className="dashboard scrollbar ps-0">
            <div className="file-information hide-mobile">
              <div className="file-information-headline">
                <div className="title">اطلاعات پرونده ی شما</div>
                <div className="title">{userData?.first_name} {userData?.last_name || ""}</div>
              </div>
              <div className="total-card-container">
                <TotalCard image={<SavedUp color="#ffffff" />} colorFull myStyle="w-30" countTitle="ریال" countValue={dashboardData?.policies_info?.total_invest} headLineTitle="مجموع اندوخته" >
                  <Button myStyle="increase-btn me-2" title="افزایش" icon={Plus} onClick={()=>{}}/>
                </TotalCard>
                <TotalCard image={<Letter />} myStyle="w-30" countTitle="ریال" countValue={dashboardData?.policies_info?.total_desth_asset} headLineTitle=" سرمایه فوت" />
                <div className="total-card-mini-container w-30">
                  <TotalCardMini image={<img src={FolderCheck} alt="هامرز" />} myStyle="" countTitle="بیمه نامه فعال" countValue={dashboardData?.policies_info?.total_active_policy} headLineTitle="بیمه نامه های فعال" />
                  <TotalCardMini showArrow isExpired image={<img src={FolderClose} alt="هامرز" />} myStyle="" countTitle="مشاهده" countValue={dashboardData?.policies_info?.total_deactive_policy} headLineTitle="بیمه نامه ها منقضی شده" />
                </div>
              </div>
            </div>
            <div className="dashboard-content hide-mobile">
              <div className="right-side">
                <div className="active-policy">

                  <div className="dashboard-content-title-status">
                    <span className="title">
                      بیمه نامه های فعال
                    </span>

                    <Link to={routes.INSURANCEPOLICY} className="status">
                      همه
                      <Arrowleft myStyle="arrow" />
                    </Link>
                  </div>
                    {dashboardData?.policies_info?.list?.length > 0 ? 
                    <>
                  <div className="active-policy-table hide-mobile">
                    {dashboardData?.policies_info?.list?.map((item: any, index: number) => {
                      return (
                        <>

                          <div className="active-policy-table-row ">
                          <PolicyInfo icon={policyIcon(item?.insurance_type)} myStyle="custom-border-left" title="بیمه نامه:" subTitle={`${planTypeList.filter((p: { value: string; }) => p.value ===  item?.insurance_type)[0]?.title}`} />


                            <PolicyInfo myStyle="custom-border-left" title="شماره بیمه نامه :" subTitle={item?.idinsu} />

                            <PolicyInfo myStyle="custom-border-left" title="وضعیت بیمه نامه:" subTitle={item?.state} />

                            <PolicyInfo title="میزان اندوخته:" subTitle={"---"}  colorful link={`/insurance-policy-details/${item?.id}`}/>
                          </div>
                          {index === 0 &&
                            <div className="custom-border-bottom"></div>
                          }
                        </>
                      )
                    })}

                  </div>
                    </> 

                    :
                    <div className="empty-list-text">
                    بیمه نامه ای ثبت نشده است .  
                    </div>
                  }
                </div>

                <div className="chart-selected-funds">
                  <div className="chart-selected-funds-headline">
                    <span className="title">
                      <img src={Chart} className="ms-2" alt="هامرز" />
                      نمودار صندوق های منتخب
                    </span>

                    {/* <div className="chart-title">
                      <div className="roshd">
                        <span className="roshd-badge t"></span>
                        <span className="roshd-title"> صندوق اول </span>

                      </div>
                      <div className="roshd ">
                        <span className="roshd-badge p"></span>
                        <span className="roshd-title"> صندوق دوم    </span>

                      </div>
                    </div> */}
                  </div>


                  <Line
                    width={100}
                    height={100}
                    data={this.state.data}
                    options={this.state.options}
                  />


                </div>
              </div>
              <div className="left-side ">

                <div className="dashboard-content-title-status">
                  <span className="title">
                    محصولات هامرز
                  </span>

                  
                </div>

                <div className="scrollbar hide-mobile">

                  {dashboardData?.products?.map((item: any, index: number) => {
                    return (
                      <ProductCard badge={item.bought === true ? true : false} title={item?.name} img={productIcon(item?.insurance_type)} onClick={insuranceTypeList.filter((p: { value: string; }) => p.value ===  item?.insurance_type)[0]?.url} /> 

                    )
                  })}

                </div>



              </div>


            </div>
            <div className="dashboard-responsive-content hide-desktop">

              <div className="category-list">
                <CategoryCard  title="اندوخته" icon={MoneySend}/>
                <CategoryCard link={routes.INSURANCEPOLICY} title="بیمه نامه ها" icon={Policy}/>
                <CategoryCard  title=" سرمایه فوت" icon={WalletMoney}/>
                <CategoryCard  title="نمودار" icon={BarChart}/>

              </div>
            
              <div className="polices-list-mobile ">
              {dashboardData?.policies_info?.list?.length > 0 ? 
                    <>
                    <span className="polices-list-mobile-title">
                  بیمه نامه های فعال 
                </span>
                   
              
                      <Swiper 
                        slidesPerView={'auto'}
                        spaceBetween={10}
                        pagination={{
                          clickable: true,
                        }}
                        className="polices-swiper-slide"

                        
                      >
                        {dashboardData?.policies_info?.list?.map((item: any, index: number) => {
                          return (
                            <SwiperSlide>
                              <div className="policy-card-mobile ">

                              <PolicyInfo myStyle="" title="بیمه نامه:" subTitle={`${planTypeList.filter((p: { value: string; }) => p.value ===  item?.insurance_type)[0]?.title}`} />
                                <div className="d-flex">
                                  <PolicyInfo myStyle="custom-border-left" title="وضعیت بیمه نامه:" subTitle={item?.state} />

                                  <PolicyInfo myStyle="pe-3" title="میزان اندوخته:" subTitle={"---"} colorful />
                                </div>
                                <Button myStyle="custom-button w-100 mt-2" title=" جزئیات" link={`/insurance-policy-details/${item?.id}`} />
                              </div>
                            </SwiperSlide>
                          )
                        })}
                      </Swiper>
                    </> 
                    :
                    <div className="polices-list-mobile-empty-list-text">
                    بیمه نامه ای ثبت نشده است .  
                    </div>
                  }



              </div>
              

              <div className="chart-selected-funds">
                  <div className="chart-selected-funds-headline">
                    <span className="title">
                      <img src={Chart} className="ms-2" alt="هامرز" />
                      نمودار صندوق های منتخب
                    </span>

                    {/* <div className="chart-title">
                      <div className="roshd">
                        <span className="roshd-badge t"></span>
                        <span className="roshd-title"> صندوق اول </span>

                      </div>
                      <div className="roshd ">
                        <span className="roshd-badge p"></span>
                        <span className="roshd-title"> صندوق دوم    </span>

                      </div>
                    </div> */}
                  </div>


                  <Line
                    width={100}
                    data={this.state.data}
                    options={this.state.options}
                  />


                </div>
            </div>

          </div>
        }
      </Layout>
    )
  }
}

const mapStateToProps = (dispatch: any) => {
  return {
    dispatch,
    userData: dispatch.general.userData,
  }
};

export default connect(mapStateToProps)(Dashboard);